export default {
      id: "i-project-management-usage",
      viewBox: "0 0 54 41",
      url: __webpack_public_path__ + "img/sprite.svg#i-project-management",
      toString: function () {
        return this.url;
      }
    }